var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"delegacion"},[_c('DocumentosDelegacionTable',{attrs:{"params":_vm.params,"fieldsI":_vm.fields},on:{"update:fieldsI":function($event){_vm.fields=$event},"update:fields-i":function($event){_vm.fields=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }